export default "__VITE_ASSET__hsx$bjBe__"